'use strict';

import ClassLogger from 'ClassLogger';
import { ApiClient } from './ApiClient';

/**
 *
 * @typedef {import('mitt').Emitter} EventEmitter
 * @typedef {import('./CommonMethods').default} CommonMethods
 * @typedef {import('./NavigationHandler').default} NavigationHandler
 */

export default class Ping {
    getClassName () { return 'Ping'; }

    /**
     * @param {CommonMethods} commonMethods
     * @param {NavigationHandler} navigationHandler
     */
    constructor (
        navigationHandler,
        commonMethods,
    ) {
        this.logger = ClassLogger(this, true);
        this.commonMethods = commonMethods;
        this.navigationHandler = navigationHandler;
        this.apiClient = new ApiClient();

        const shouldPing = window.antenne.config.ping;
        if (shouldPing !== false) {
            this.logger.log('Ping is enabled');
            this.navigationHandler
                .on('render', () => this.handlePageView())
                .on('ready', () => this.handlePageView());
        } else {
            this.logger.log('Ping is disabled');
        }
    }

    async handlePageView () {
        this.pingforpage = window.antenne.config.pingforpage || false;
        if (await this.checkSessionCookie()) {
            return;
        }

        if (this.pingforpage !== true) {
            return;
        }
        const requestOptions = {
            pageid: window.antenne.config.pageid,
        };
        this.apiClient.post('ping', requestOptions);
    }

    /**
     * Check if session cookie exists, if not send a session ping
     */
    async checkSessionCookie () {
        const cookieName = 'aby-sid';
        const existingCookie = this.commonMethods.getCookie(cookieName);

        // Set/update the cookie with 30 minute expiration
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (30 * 60 * 1000));
        this.commonMethods.setCookie(cookieName, '1', {
            expires: expirationDate,
        });

        if (!this.commonMethods.getCookie(cookieName)) {
            this.logger.warn('Could not write session cookie');
            return false;
        }

        // Send ping if previously no cookie exists and new cookie was successfully written
        if (!existingCookie) {
            this.logger.log('Sending session ping');
            const requestOptions = {
                session: 1,
            };

            // only add pageid if it should also create a page view
            if (this.pingforpage) {
                requestOptions.pageid = window.antenne.config.pageid;
            }
            this.apiClient.post('ping', requestOptions);

            return true;
        }

        this.logger.log('Existing session found');
        return false;
    }
}
